import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowCatalogFetchFailedAction = {
	type: 'WORKFLOW_CATALOG_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowCatalogFetchFailedAction => ({
	type: 'WORKFLOW_CATALOG_FETCH_FAILED',
	payload,
});
